<template>
  <component
    :is="iconComponent"
    v-if="iconComponent"
    class="auth-login__icon"
    :size="resolvedSize"
    :stroke-width="strokeWidth"
    aria-hidden="true"
  />
</template>

<script setup>
import { computed } from 'vue'
import {
  ArrowRight,
  Check,
  Circle,
  CheckCircle,
  Eye,
  EyeOff,
  Fingerprint,
  Info,
  Link2,
  Lock,
  Mail,
  Moon,
  Phone,
  RefreshCw,
  Smartphone,
  Stethoscope,
  Sun,
  User,
} from '@lucide/vue';

const ICONS = {
  lock: Lock,
  check: Check,
  'step-complete': Check,
  info: Info,
  phone: Phone,
  refresh: RefreshCw,
  'arrow-right': ArrowRight,
  moon: Moon,
  sun: Sun,
  mail: Mail,
  email: Mail,
  smartphone: Smartphone,
  sms: Smartphone,
  link: Link2,
  eye: Eye,
  'eye-off': EyeOff,
  user: User,
  practice: Stethoscope,
  fingerprint: Fingerprint,
  'check-circle': CheckCircle,
  'circle': Circle,
}

const DEFAULT_SIZES = {
  lock: 20,
  check: 28,
  'step-complete': 14,
  info: 20,
  phone: 20,
  refresh: 20,
  'arrow-right': 20,
  moon: 20,
  sun: 20,
  mail: 20,
  email: 20,
  smartphone: 20,
  sms: 20,
  link: 20,
  eye: 20,
  'eye-off': 20,
  user: 20,
  practice: 20,
  fingerprint: 20,
}

const props = defineProps({
  name:        { type: String, required: true },
  size:        { type: [Number, String], default: null },
  strokeWidth: { type: [Number, String], default: 2 },
})

const iconComponent = computed(() => ICONS[props.name] ?? null)

const resolvedSize = computed(() => {
  if (props.size != null && props.size !== '') {
    return Number(props.size)
  }

  return DEFAULT_SIZES[props.name] ?? 20
})
</script>
